export default __webpack_public_path__ + "static/media/adduserscreen.2b6cc961.png";